module.exports = __webpack_public_path__ + "media/images/kids3-bfb9ac01eac5ee9820e6a3910e6c2774.jpg";